import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { pages } from "../../data/pages";
import contactsIcons from "../../data/contactsIcons";

function Footer({ contacts }) {
  const { pathname } = useLocation();
  return (
    <>
      {pathname !== "/join/verify" && (
        <>
          <footer className="footer bg-base-200 text-base-content p-10">
            <nav>
              <NavLink to="/" className="hover:text-custom-blue">
                About us
              </NavLink>
              <NavLink
                to="/resources?pagename=contacts&type=support"
                className="hover:text-custom-blue"
              >
                Contacts
              </NavLink>
              <NavLink
                to="/resources?pagename=donates&type=support"
                className="hover:text-custom-blue"
              >
                Donates
              </NavLink>
            </nav>
            <nav>
              {pages.map(
                (item) =>
                  item.id !== "about" &&
                  item.id !== "donates" &&
                  item.id !== "contacts" && (
                    <NavLink
                      to={item.path}
                      key={item.id}
                      className={` hover:text-custom-blue
            `}
                    >
                      {item.text}
                    </NavLink>
                  )
              )}
            </nav>
          </footer>
          <footer className="footer bg-base-200 text-base-content border-base-300 border-t px-10 py-4">
            <aside className="grid-flow-col items-center">
              <div className="flex flex-col w-52 h-16">
                <img src="/images/logo.png" alt="ss" />
                <img src="/images/sologan.png" alt="ss" />
              </div>
            </aside>
            <nav className="md:place-self-center md:justify-self-end">
              <div className="grid grid-flow-col gap-4">
                {contacts.constructor === Array
                  ? contacts.map((contact) => {
                      let icon = "fa-solid fa-globe";
                      // contact.type;
                      contactsIcons.forEach((i) => {
                        console.log(i.name);
                        if (contact.type.toLowerCase() === i.name) {
                          icon = i.icon;
                        }
                      });
                      console.log(icon);
                      return (
                        <a href={contact.url}>
                          <i className={`${icon} text-xl  `} />
                        </a>
                      );
                    })
                  : contacts}
              </div>
            </nav>
          </footer>
        </>
      )}
    </>
  );
}
export default Footer;
